import { render } from "./index.vue?vue&type=template&id=a2abfb0a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a2abfb0a&lang=less&scoped=true"

import exportComponent from "/Users/macpc/Documents/WORK/project/Rail_transit_exper_mental_platform/源代码/实验综合平台/experimentalSynthesisUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2abfb0a"]])

export default __exports__